module.exports = __webpack_public_path__ + "img/play.be5030ca.webp";